import React, { useContext, useEffect, useState } from "react";
import CrudTable from "../../components/CrudTable";
import Title from "../../components/Title";
import { useQuery, gql, useLazyQuery } from "@apollo/client";
import {
  IDropdownStyles,
  IDropdownOption,
  Dropdown,
  Stack,
  IStackTokens,
  Spinner,
  SpinnerSize,
  ICommandBarItemProps,
  CommandBar,
  Checkbox,
} from "@fluentui/react";
import AppContext, { IVenta } from "../../AppContext";
import { normalize } from "../../utils/functions";
import exportFromJSON from "export-from-json";
import moment from "moment";
import "./style.scss";

const Ventas = () => {
  const { semanasDatos } = useContext(AppContext);

  const currentYear = moment().year();
  const currentWeek = moment().isoWeek();

  const [selectedWeek, setSelectedWeek] = useState<IDropdownOption | null>({
    key: currentWeek,
    text: `${currentWeek - 1}`,
  });
  const [selectedYear, setSelectedYear] = useState<IDropdownOption | null>({
    key: currentYear,
    text: `${currentYear}`,
  });
  const [selectedCadena, setSelectedCadena] = useState<IDropdownOption | null>(
    null
  );

  const addQuery = gql`
    mutation ($nombre: String!) {
      setVenta(input: { UUID: $currId }) {
        UUID
        Nombre
        Error
      }
    }
  `;
  const setQuery = gql`
    mutation ($currId: String!, $nombre: String!) {
      setVenta(input: { UUID: $currId }) {
        UUID
        Nombre
        Error
      }
    }
  `;
  const deleteQuery = gql`
    mutation ($currId: String!) {
      deleteVenta(input: { UUID: $currId }) {
        Completed
        Error
      }
    }
  `;

  const CADENAS = gql`
    query {
      getCadena {
        Nombre
        hasVentas
      }
    }
  `;

  const VENTAS_QRY = gql`
  query ($year: Int, $wk1: Int, $wk2: Int) {
    getVenta(
      WeekRange: {
        Start: { Year: $year, Week: $wk1 }
        End: { Year: $year, Week: $wk2 }
      }
      ShowAll: true
    ) {
      UUID
      Cadena {
        Nombre
        Segmento {
          Descripcion
        }
      }
      Semana
      Anyo
      LastYear {
  VentasComp_CurrentYear
  VentasComp_Last
  TicketsComp_CurrentYear
  TicketsComp_Last
  LocalesComp_CurrentYear
  LocalesComp_Last
  LocalesRepComp_CurrentYear
  LocalesRepComp_Last
  Del_VentasComp_CurrentYear
  Del_VentasComp_Last
  Taw_VentasComp_CurrentYear
  Taw_VentasComp_Last
  Local_VentasComp_CurrentYear
  Local_VentasComp_Last
  Del_TicketsComp_CurrentYear
  Del_TicketsComp_Last
  Taw_TicketsComp_CurrentYear
  Taw_TicketsComp_Last
  Local_TicketsComp_CurrentYear
  Local_TicketsComp_Last
  Calle_VentasComp_CurrentYear
  Calle_VentasComp_Last
  CC_VentasComp_CurrentYear
  CC_VentasComp_Last
  Conces_VentasComp_CurrentYear
  Conces_VentasComp_Last
  Otros_VentasComp_CurrentYear
  Otros_VentasComp_Last
  Calle_TicketsComp_CurrentYear
  Calle_TicketsComp_Last
  CC_TicketsComp_CurrentYear
  CC_TicketsComp_Last
  Conces_TicketsComp_CurrentYear
  Conces_TicketsComp_Last
  Otros_TicketsComp_CurrentYear
  Otros_TicketsComp_Last
  Z1_VentasComp_CurrentYear
  Z1_VentasComp_Last
  Z2_VentasComp_CurrentYear
  Z2_VentasComp_Last
  Z3_VentasComp_CurrentYear
  Z3_VentasComp_Last
  Z4_VentasComp_CurrentYear
  Z4_VentasComp_Last
  Z5_VentasComp_CurrentYear
  Z5_VentasComp_Last
  Z6_VentasComp_CurrentYear
  Z6_VentasComp_Last
  Z1_TicketsComp_CurrentYear
  Z1_TicketsComp_Last
  Z2_TicketsComp_CurrentYear
  Z2_TicketsComp_Last
  Z3_TicketsComp_CurrentYear
  Z3_TicketsComp_Last
  Z4_TicketsComp_CurrentYear
  Z4_TicketsComp_Last
  Z5_TicketsComp_CurrentYear
  Z5_TicketsComp_Last
  Z6_TicketsComp_CurrentYear
  Z6_TicketsComp_Last
  T1_VentasComp_CurrentYear
  T1_VentasComp_Last
  T2_VentasComp_CurrentYear
  T2_VentasComp_Last
  T3_VentasComp_CurrentYear
  T3_VentasComp_Last
  T4_VentasComp_CurrentYear
  T4_VentasComp_Last
  T5_VentasComp_CurrentYear
  T5_VentasComp_Last
  T6_VentasComp_CurrentYear
  T6_VentasComp_Last
  T1_TicketsComp_CurrentYear
  T1_TicketsComp_Last
  T2_TicketsComp_CurrentYear
  T2_TicketsComp_Last
  T3_TicketsComp_CurrentYear
  T3_TicketsComp_Last
  T4_TicketsComp_CurrentYear
  T4_TicketsComp_Last
  T5_TicketsComp_CurrentYear
  T5_TicketsComp_Last
  T6_TicketsComp_CurrentYear
  T6_TicketsComp_Last
      }
      Actual {
        Ventas {
          Bruto {
            Totales
            Canal {
              Delivery
              TakeAway
              Local
            }
            Ubicacion {
              Calle
              CC
              Concesiones
              Otros
            }
            Region {
              Z1
              Z2
              Z3
              Z4
              Z5
              Z6
            }
            Momento {
              T1
              T2
              T3
              T4
              T5
              T6
            }
          }
          Comparable {
            Totales
            Canal {
              Delivery
              TakeAway
              Local
            }
            Ubicacion {
              Calle
              CC
              Concesiones
              Otros
            }
            Region {
              Z1
              Z2
              Z3
              Z4
              Z5
              Z6
            }
            Momento {
              T1
              T2
              T3
              T4
              T5
              T6
            }
          }
        }
        Tickets {
          Bruto {
            Totales
            Canal {
              Delivery
              TakeAway
              Local
            }
            Ubicacion {
              Calle
              CC
              Concesiones
              Otros
            }
            Region {
              Z1
              Z2
              Z3
              Z4
              Z5
              Z6
            }
            Momento {
              T1
              T2
              T3
              T4
              T5
              T6
            }
          }
          Comparable {
            Totales
            Canal {
              Delivery
              TakeAway
              Local
            }
            Ubicacion {
              Calle
              CC
              Concesiones
              Otros
            }
            Region {
              Z1
              Z2
              Z3
              Z4
              Z5
              Z6
            }
            Momento {
              T1
              T2
              T3
              T4
              T5
              T6
            }
          }
        }
        Locales {
          Aperturas
          Cierres
          Bruto {
            Total
            Reportan
            Self
            Delivery
            Region {
              Z1
              Z2
              Z3
              Z4
              Z5
              Z6
            }
          }
          Comparable {
            Total
            Reportan
          }
        }
        Agregadores {
          Ventas
          VentasAP
          Tickets
          TicketsAP
        }
        Propios {
          Ventas
          VentasAP
          Tickets
          TicketsAP
        }
        Turismo {
          Ventas
          VentasAP
          Tickets
          TicketsAP
        }
      }
      Anterior {
        Ventas {
          Bruto {
            Totales
            Canal {
              Delivery
              TakeAway
              Local
            }
            Ubicacion {
              Calle
              CC
              Concesiones
              Otros
            }
            Region {
              Z1
              Z2
              Z3
              Z4
              Z5
              Z6
            }
            Momento {
              T1
              T2
              T3
              T4
              T5
              T6
            }
          }
          Comparable {
            Totales
            Canal {
              Delivery
              TakeAway
              Local
            }
            Ubicacion {
              Calle
              CC
              Concesiones
              Otros
            }
            Region {
              Z1
              Z2
              Z3
              Z4
              Z5
              Z6
            }
            Momento {
              T1
              T2
              T3
              T4
              T5
              T6
            }
          }
        }
        Tickets {
          Bruto {
            Totales
            Canal {
              Delivery
              TakeAway
              Local
            }
            Ubicacion {
              Calle
              CC
              Concesiones
              Otros
            }
            Region {
              Z1
              Z2
              Z3
              Z4
              Z5
              Z6
            }
            Momento {
              T1
              T2
              T3
              T4
              T5
              T6
            }
          }
          Comparable {
            Totales
            Canal {
              Delivery
              TakeAway
              Local
            }
            Ubicacion {
              Calle
              CC
              Concesiones
              Otros
            }
            Region {
              Z1
              Z2
              Z3
              Z4
              Z5
              Z6
            }
            Momento {
              T1
              T2
              T3
              T4
              T5
              T6
            }
          }
        }
        Locales {
          Aperturas
          Cierres
          Bruto {
            Total
            Reportan
            Self
            Delivery
            Region {
              Z1
              Z2
              Z3
              Z4
              Z5
              Z6
            }
          }
          Comparable {
            Total
            Reportan
          }
        }
        Agregadores {
          Ventas
          VentasAP
          Tickets
          TicketsAP
        }
        Propios {
          Ventas
          VentasAP
          Tickets
          TicketsAP
        }
        Turismo {
          Ventas
          VentasAP
          Tickets
          TicketsAP
        }
      }
      Modelizacion
      Ratio
    }
  }
`;

const VENTAS_QRY_CAD = gql`
query ($cad: String!) {
  getVenta(Cadena: { Nombre: $cad }, ShowAll: true) {
    UUID
    Cadena {
      Nombre
      Segmento {
        Descripcion
      }
    }
    Semana
    Anyo
    LastYear {
  VentasComp_CurrentYear
  VentasComp_Last
  TicketsComp_CurrentYear
  TicketsComp_Last
  LocalesComp_CurrentYear
  LocalesComp_Last
  LocalesRepComp_CurrentYear
  LocalesRepComp_Last
  Del_VentasComp_CurrentYear
  Del_VentasComp_Last
  Taw_VentasComp_CurrentYear
  Taw_VentasComp_Last
  Local_VentasComp_CurrentYear
  Local_VentasComp_Last
  Del_TicketsComp_CurrentYear
  Del_TicketsComp_Last
  Taw_TicketsComp_CurrentYear
  Taw_TicketsComp_Last
  Local_TicketsComp_CurrentYear
  Local_TicketsComp_Last
  Calle_VentasComp_CurrentYear
  Calle_VentasComp_Last
  CC_VentasComp_CurrentYear
  CC_VentasComp_Last
  Conces_VentasComp_CurrentYear
  Conces_VentasComp_Last
  Otros_VentasComp_CurrentYear
  Otros_VentasComp_Last
  Calle_TicketsComp_CurrentYear
  Calle_TicketsComp_Last
  CC_TicketsComp_CurrentYear
  CC_TicketsComp_Last
  Conces_TicketsComp_CurrentYear
  Conces_TicketsComp_Last
  Otros_TicketsComp_CurrentYear
  Otros_TicketsComp_Last
  Z1_VentasComp_CurrentYear
  Z1_VentasComp_Last
  Z2_VentasComp_CurrentYear
  Z2_VentasComp_Last
  Z3_VentasComp_CurrentYear
  Z3_VentasComp_Last
  Z4_VentasComp_CurrentYear
  Z4_VentasComp_Last
  Z5_VentasComp_CurrentYear
  Z5_VentasComp_Last
  Z6_VentasComp_CurrentYear
  Z6_VentasComp_Last
  Z1_TicketsComp_CurrentYear
  Z1_TicketsComp_Last
  Z2_TicketsComp_CurrentYear
  Z2_TicketsComp_Last
  Z3_TicketsComp_CurrentYear
  Z3_TicketsComp_Last
  Z4_TicketsComp_CurrentYear
  Z4_TicketsComp_Last
  Z5_TicketsComp_CurrentYear
  Z5_TicketsComp_Last
  Z6_TicketsComp_CurrentYear
  Z6_TicketsComp_Last
  T1_VentasComp_CurrentYear
  T1_VentasComp_Last
  T2_VentasComp_CurrentYear
  T2_VentasComp_Last
  T3_VentasComp_CurrentYear
  T3_VentasComp_Last
  T4_VentasComp_CurrentYear
  T4_VentasComp_Last
  T5_VentasComp_CurrentYear
  T5_VentasComp_Last
  T6_VentasComp_CurrentYear
  T6_VentasComp_Last
  T1_TicketsComp_CurrentYear
  T1_TicketsComp_Last
  T2_TicketsComp_CurrentYear
  T2_TicketsComp_Last
  T3_TicketsComp_CurrentYear
  T3_TicketsComp_Last
  T4_TicketsComp_CurrentYear
  T4_TicketsComp_Last
  T5_TicketsComp_CurrentYear
  T5_TicketsComp_Last
  T6_TicketsComp_CurrentYear
  T6_TicketsComp_Last
    }
    Actual {
      Ventas {
        Bruto {
          Totales
          Canal {
            Delivery
            TakeAway
            Local
          }
          Ubicacion {
            Calle
            CC
            Concesiones
            Otros
          }
          Region {
            Z1
            Z2
            Z3
            Z4
            Z5
            Z6
          }
          Momento {
            T1
            T2
            T3
            T4
            T5
            T6
          }
        }
        Comparable {
          Totales
          Canal {
            Delivery
            TakeAway
            Local
          }
          Ubicacion {
            Calle
            CC
            Concesiones
            Otros
          }
          Region {
            Z1
            Z2
            Z3
            Z4
            Z5
            Z6
          }
          Momento {
            T1
            T2
            T3
            T4
            T5
            T6
          }
        }
      }
      Tickets {
        Bruto {
          Totales
          Canal {
            Delivery
            TakeAway
            Local
          }
          Ubicacion {
            Calle
            CC
            Concesiones
            Otros
          }
          Region {
            Z1
            Z2
            Z3
            Z4
            Z5
            Z6
          }
          Momento {
            T1
            T2
            T3
            T4
            T5
            T6
          }
        }
        Comparable {
          Totales
          Canal {
            Delivery
            TakeAway
            Local
          }
          Ubicacion {
            Calle
            CC
            Concesiones
            Otros
          }
          Region {
            Z1
            Z2
            Z3
            Z4
            Z5
            Z6
          }
          Momento {
            T1
            T2
            T3
            T4
            T5
            T6
          }
        }
      }
      Locales {
        Aperturas
        Cierres
        Bruto {
          Total
          Reportan
          Self
          Delivery
          Region {
            Z1
            Z2
            Z3
            Z4
            Z5
            Z6
          }
        }
        Comparable {
          Total
          Reportan
        }
      }
      Agregadores {
        Ventas
        VentasAP
        Tickets
        TicketsAP
      }
      Propios {
        Ventas
        VentasAP
        Tickets
        TicketsAP
      }
      Turismo {
        Ventas
        VentasAP
        Tickets
        TicketsAP
      }
    }
    Anterior {
      Ventas {
        Bruto {
          Totales
          Canal {
            Delivery
            TakeAway
            Local
          }
          Ubicacion {
            Calle
            CC
            Concesiones
            Otros
          }
          Region {
            Z1
            Z2
            Z3
            Z4
            Z5
            Z6
          }
          Momento {
            T1
            T2
            T3
            T4
            T5
            T6
          }
        }
        Comparable {
          Totales
          Canal {
            Delivery
            TakeAway
            Local
          }
          Ubicacion {
            Calle
            CC
            Concesiones
            Otros
          }
          Region {
            Z1
            Z2
            Z3
            Z4
            Z5
            Z6
          }
          Momento {
            T1
            T2
            T3
            T4
            T5
            T6
          }
        }
      }
      Tickets {
        Bruto {
          Totales
          Canal {
            Delivery
            TakeAway
            Local
          }
          Ubicacion {
            Calle
            CC
            Concesiones
            Otros
          }
          Region {
            Z1
            Z2
            Z3
            Z4
            Z5
            Z6
          }
          Momento {
            T1
            T2
            T3
            T4
            T5
            T6
          }
        }
        Comparable {
          Totales
          Canal {
            Delivery
            TakeAway
            Local
          }
          Ubicacion {
            Calle
            CC
            Concesiones
            Otros
          }
          Region {
            Z1
            Z2
            Z3
            Z4
            Z5
            Z6
          }
          Momento {
            T1
            T2
            T3
            T4
            T5
            T6
          }
        }
      }
      Locales {
        Aperturas
        Cierres
        Bruto {
          Total
          Reportan
          Self
          Delivery
          Region {
            Z1
            Z2
            Z3
            Z4
            Z5
            Z6
          }
        }
        Comparable {
          Total
          Reportan
        }
      }
      Agregadores {
        Ventas
        VentasAP
        Tickets
        TicketsAP
      }
      Propios {
        Ventas
        VentasAP
        Tickets
        TicketsAP
      }
      Turismo {
        Ventas
        VentasAP
        Tickets
        TicketsAP
      }
    }
    Modelizacion
    Ratio
  }
}
`;

  const {
    data: ventasData,
    refetch,
    loading: ventasLoading,
  } = useQuery(VENTAS_QRY, {
    variables: {
      year: selectedYear?.key,
      wk1: selectedWeek?.key ?? 2,
      wk2: selectedWeek?.key ?? 53,
    },
    fetchPolicy: "no-cache",
  });

  const [modifiedVentasData, setMVentasData] = useState<any>([]);

  useEffect(() => {
    if (ventasData === undefined) return;

    let ventasData2 = ventasData.getVenta.map((i: any) => ({
      ...i,
      Semana: i.Semana - 1,
    }));

    let ventasData3 = ventasData2.filter((i: any) => i.Semana !== 0);

    if (selectedCadena) {
      ventasData3 = ventasData3.filter(
        (i: any) => i.Cadena?.Nombre === selectedCadena.key
      );
    }

    setMVentasData(ventasData3);
  }, [ventasData, selectedCadena]);

  const normalizeStr = [
    "No definido",
    "No modelizado",
    "Suma de partes",
    "Total",
  ];

  const source = {
    datafields: [
      { name: "UUID", type: "string", readonly: true },
      { name: "Semana", type: "number" },
      { name: "Anyo", type: "number" },
      { name: "Cadena", map: "Cadena>Nombre", type: "string" },
      { name: "Segmento", map: "Cadena>Segmento", type: "array" },
      { name: "Ratio", type: "number" },
      { name: "Modelizacion", type: "number" },

      {
        name: "VentasBrutoTotales",
        map: "Actual>Ventas>Bruto>Totales",
        type: "number",
      },
      {
        name: "VentasBrutoCanalDelivery",
        map: "Actual>Ventas>Bruto>Canal>Delivery",
        type: "number",
      },
      {
        name: "VentasBrutoCanalTakeAway",
        map: "Actual>Ventas>Bruto>Canal>TakeAway",
        type: "number",
      },
      {
        name: "VentasBrutoCanalLocal",
        map: "Actual>Ventas>Bruto>Canal>Local",
        type: "number",
      },
      {
        name: "VentasBrutoUbicacionCalle",
        map: "Actual>Ventas>Bruto>Ubicacion>Calle",
        type: "number",
      },
      {
        name: "VentasBrutoUbicacionCC",
        map: "Actual>Ventas>Bruto>Ubicacion>CC",
        type: "number",
      },
      {
        name: "VentasBrutoUbicacionConcesiones",
        map: "Actual>Ventas>Bruto>Ubicacion>Concesiones",
        type: "number",
      },
      {
        name: "VentasBrutoUbicacionOtros",
        map: "Actual>Ventas>Bruto>Ubicacion>Otros",
        type: "number",
      },
      {
        name: "VentasBrutoRegionZ1",
        map: "Actual>Ventas>Bruto>Region>Z1",
        type: "number",
      },
      {
        name: "VentasBrutoRegionZ2",
        map: "Actual>Ventas>Bruto>Region>Z2",
        type: "number",
      },
      {
        name: "VentasBrutoRegionZ3",
        map: "Actual>Ventas>Bruto>Region>Z3",
        type: "number",
      },
      {
        name: "VentasBrutoRegionZ4",
        map: "Actual>Ventas>Bruto>Region>Z4",
        type: "number",
      },
      {
        name: "VentasBrutoRegionZ5",
        map: "Actual>Ventas>Bruto>Region>Z5",
        type: "number",
      },
      {
        name: "VentasBrutoRegionZ6",
        map: "Actual>Ventas>Bruto>Region>Z6",
        type: "number",
      },
      {
        name: "VentasBrutoMomentoT1",
        map: "Actual>Ventas>Bruto>Momento>T1",
        type: "number",
      },
      {
        name: "VentasBrutoMomentoT2",
        map: "Actual>Ventas>Bruto>Momento>T2",
        type: "number",
      },
      {
        name: "VentasBrutoMomentoT3",
        map: "Actual>Ventas>Bruto>Momento>T3",
        type: "number",
      },
      {
        name: "VentasBrutoMomentoT4",
        map: "Actual>Ventas>Bruto>Momento>T4",
        type: "number",
      },
      {
        name: "VentasBrutoMomentoT5",
        map: "Actual>Ventas>Bruto>Momento>T5",
        type: "number",
      },
      {
        name: "VentasBrutoMomentoT6",
        map: "Actual>Ventas>Bruto>Momento>T6",
        type: "number",
      },
      {
        name: "VentasComparableTotales",
        map: "Actual>Ventas>Comparable>Totales",
        type: "number",
      },
      {
        name: "VentasComparableCanalDelivery",
        map: "Actual>Ventas>Comparable>Canal>Delivery",
        type: "number",
      },
      {
        name: "VentasComparableCanalTakeAway",
        map: "Actual>Ventas>Comparable>Canal>TakeAway",
        type: "number",
      },
      {
        name: "VentasComparableCanalLocal",
        map: "Actual>Ventas>Comparable>Canal>Local",
        type: "number",
      },
      {
        name: "VentasComparableUbicacionCalle",
        map: "Actual>Ventas>Comparable>Ubicacion>Calle",
        type: "number",
      },
      {
        name: "VentasComparableUbicacionCC",
        map: "Actual>Ventas>Comparable>Ubicacion>CC",
        type: "number",
      },
      {
        name: "VentasComparableUbicacionConcesiones",
        map: "Actual>Ventas>Comparable>Ubicacion>Concesiones",
        type: "number",
      },
      {
        name: "VentasComparableUbicacionOtros",
        map: "Actual>Ventas>Comparable>Ubicacion>Otros",
        type: "number",
      },
      {
        name: "VentasComparableRegionZ1",
        map: "Actual>Ventas>Comparable>Region>Z1",
        type: "number",
      },
      {
        name: "VentasComparableRegionZ2",
        map: "Actual>Ventas>Comparable>Region>Z2",
        type: "number",
      },
      {
        name: "VentasComparableRegionZ3",
        map: "Actual>Ventas>Comparable>Region>Z3",
        type: "number",
      },
      {
        name: "VentasComparableRegionZ4",
        map: "Actual>Ventas>Comparable>Region>Z4",
        type: "number",
      },
      {
        name: "VentasComparableRegionZ5",
        map: "Actual>Ventas>Comparable>Region>Z5",
        type: "number",
      },
      {
        name: "VentasComparableRegionZ6",
        map: "Actual>Ventas>Comparable>Region>Z6",
        type: "number",
      },
      {
        name: "VentasComparableMomentoT1",
        map: "Actual>Ventas>Comparable>Momento>T1",
        type: "number",
      },
      {
        name: "VentasComparableMomentoT2",
        map: "Actual>Ventas>Comparable>Momento>T2",
        type: "number",
      },
      {
        name: "VentasComparableMomentoT3",
        map: "Actual>Ventas>Comparable>Momento>T3",
        type: "number",
      },
      {
        name: "VentasComparableMomentoT4",
        map: "Actual>Ventas>Comparable>Momento>T4",
        type: "number",
      },
      {
        name: "VentasComparableMomentoT5",
        map: "Actual>Ventas>Comparable>Momento>T5",
        type: "number",
      },
      {
        name: "VentasComparableMomentoT6",
        map: "Actual>Ventas>Comparable>Momento>T6",
        type: "number",
      },
      {
        name: "TicketsBrutoTotales",
        map: "Actual>TicketsBruto>Totales",
        type: "number",
      },
      {
        name: "TicketsBrutoCanalDelivery",
        map: "Actual>TicketsBruto>Canal>Delivery",
        type: "number",
      },
      {
        name: "TicketsBrutoCanalTakeAway",
        map: "Actual>TicketsBruto>Canal>TakeAway",
        type: "number",
      },
      {
        name: "TicketsBrutoCanalLocal",
        map: "Actual>TicketsBruto>Canal>Local",
        type: "number",
      },
      {
        name: "TicketsBrutoUbicacionCalle",
        map: "Actual>TicketsBruto>Ubicacion>Calle",
        type: "number",
      },
      {
        name: "TicketsBrutoUbicacionCC",
        map: "Actual>TicketsBruto>Ubicacion>CC",
        type: "number",
      },
      {
        name: "TicketsBrutoUbicacionConcesiones",
        map: "Actual>TicketsBruto>Ubicacion>Concesiones",
        type: "number",
      },
      {
        name: "TicketsBrutoUbicacionOtros",
        map: "Actual>TicketsBruto>Ubicacion>Otros",
        type: "number",
      },
      {
        name: "TicketsBrutoRegionZ1",
        map: "Actual>TicketsBruto>Region>Z1",
        type: "number",
      },
      {
        name: "TicketsBrutoRegionZ2",
        map: "Actual>TicketsBruto>Region>Z2",
        type: "number",
      },
      {
        name: "TicketsBrutoRegionZ3",
        map: "Actual>TicketsBruto>Region>Z3",
        type: "number",
      },
      {
        name: "TicketsBrutoRegionZ4",
        map: "Actual>TicketsBruto>Region>Z4",
        type: "number",
      },
      {
        name: "TicketsBrutoRegionZ5",
        map: "Actual>TicketsBruto>Region>Z5",
        type: "number",
      },
      {
        name: "TicketsBrutoRegionZ6",
        map: "Actual>TicketsBruto>Region>Z6",
        type: "number",
      },
      {
        name: "TicketsBrutoMomentoT1",
        map: "Actual>TicketsBruto>Momento>T1",
        type: "number",
      },
      {
        name: "TicketsBrutoMomentoT2",
        map: "Actual>TicketsBruto>Momento>T2",
        type: "number",
      },
      {
        name: "TicketsBrutoMomentoT3",
        map: "Actual>TicketsBruto>Momento>T3",
        type: "number",
      },
      {
        name: "TicketsBrutoMomentoT4",
        map: "Actual>TicketsBruto>Momento>T4",
        type: "number",
      },
      {
        name: "TicketsBrutoMomentoT5",
        map: "Actual>TicketsBruto>Momento>T5",
        type: "number",
      },
      {
        name: "TicketsBrutoMomentoT6",
        map: "Actual>TicketsBruto>Momento>T6",
        type: "number",
      },
      {
        name: "TicketsComparableTotales",
        map: "Actual>TicketsComparable>Totales",
        type: "number",
      },
      {
        name: "TicketsComparableCanalDelivery",
        map: "Actual>TicketsComparable>Canal>Delivery",
        type: "number",
      },
      {
        name: "TicketsComparableCanalTakeAway",
        map: "Actual>TicketsComparable>Canal>TakeAway",
        type: "number",
      },
      {
        name: "TicketsComparableCanalLocal",
        map: "Actual>TicketsComparable>Canal>Local",
        type: "number",
      },
      {
        name: "TicketsComparableUbicacionCalle",
        map: "Actual>TicketsComparable>Ubicacion>Calle",
        type: "number",
      },
      {
        name: "TicketsComparableUbicacionCC",
        map: "Actual>TicketsComparable>Ubicacion>CC",
        type: "number",
      },
      {
        name: "TicketsComparableUbicacionConcesiones",
        map: "Actual>TicketsComparable>Ubicacion>Concesiones",
        type: "number",
      },
      {
        name: "TicketsComparableUbicacionOtros",
        map: "Actual>TicketsComparable>Ubicacion>Otros",
        type: "number",
      },
      {
        name: "TicketsComparableRegionZ1",
        map: "Actual>TicketsComparable>Region>Z1",
        type: "number",
      },
      {
        name: "TicketsComparableRegionZ2",
        map: "Actual>TicketsComparable>Region>Z2",
        type: "number",
      },
      {
        name: "TicketsComparableRegionZ3",
        map: "Actual>TicketsComparable>Region>Z3",
        type: "number",
      },
      {
        name: "TicketsComparableRegionZ4",
        map: "Actual>TicketsComparable>Region>Z4",
        type: "number",
      },
      {
        name: "TicketsComparableRegionZ5",
        map: "Actual>TicketsComparable>Region>Z5",
        type: "number",
      },
      {
        name: "TicketsComparableRegionZ6",
        map: "Actual>TicketsComparable>Region>Z6",
        type: "number",
      },
      {
        name: "TicketsComparableMomentoT1",
        map: "Actual>TicketsComparable>Momento>T1",
        type: "number",
      },
      {
        name: "TicketsComparableMomentoT2",
        map: "Actual>TicketsComparable>Momento>T2",
        type: "number",
      },
      {
        name: "TicketsComparableMomentoT3",
        map: "Actual>TicketsComparable>Momento>T3",
        type: "number",
      },
      {
        name: "TicketsComparableMomentoT4",
        map: "Actual>TicketsComparable>Momento>T4",
        type: "number",
      },
      {
        name: "TicketsComparableMomentoT5",
        map: "Actual>TicketsComparable>Momento>T5",
        type: "number",
      },
      {
        name: "TicketsComparableMomentoT6",
        map: "Actual>TicketsComparable>Momento>T6",
        type: "number",
      },
      {
        name: "LocalesAperturas",
        map: "Actual>Locales>Aperturas",
        type: "number",
      },
      { name: "LocalesCierres", map: "Actual>Locales>Cierres", type: "number" },
      {
        name: "LocalesBrutoTotal",
        map: "Actual>Locales>Bruto>Total",
        type: "number",
      },
      {
        name: "LocalesBrutoReportan",
        map: "Actual>Locales>Bruto>Reportan",
        type: "number",
      },
      {
        name: "LocalesBrutoSelf",
        map: "Actual>Locales>Bruto>Self",
        type: "number",
      },
      {
        name: "LocalesBrutoDelivery",
        map: "Actual>Locales>Bruto>Delivery",
        type: "number",
      },
      {
        name: "LocalesComparableTotal",
        map: "Actual>Locales>Comparable>Total",
        type: "number",
      },
      {
        name: "LocalesComparableReportan",
        map: "Actual>Locales>Comparable>Reportan",
        type: "number",
      },
      {
        name: "LocalesBrutoRegionZ1",
        map: "Actual>Locales>Bruto>Region>Z1",
        type: "number",
      },
      {
        name: "LocalesBrutoRegionZ2",
        map: "Actual>Locales>Bruto>Region>Z2",
        type: "number",
      },
      {
        name: "LocalesBrutoRegionZ3",
        map: "Actual>Locales>Bruto>Region>Z3",
        type: "number",
      },
      {
        name: "LocalesBrutoRegionZ4",
        map: "Actual>Locales>Bruto>Region>Z4",
        type: "number",
      },
      {
        name: "LocalesBrutoRegionZ5",
        map: "Actual>Locales>Bruto>Region>Z5",
        type: "number",
      },
      {
        name: "LocalesBrutoRegionZ6",
        map: "Actual>Locales>Bruto>Region>Z6",
        type: "number",
      },
      {
        name: "AgregadoresVentas",
        map: "Actual>Agregadores>Ventas",
        type: "number",
      },
      {
        name: "AgregadoresVentasAP",
        map: "Actual>Agregadores>VentasAP",
        type: "number",
      },
      {
        name: "AgregadoresTickets",
        map: "Actual>Agregadores>Tickets",
        type: "number",
      },
      {
        name: "AgregadoresTicketsAP",
        map: "Actual>Agregadores>TicketsAP",
        type: "number",
      },
      {
        name: "PropiosVentas",
        map: "Actual>Propios>Ventas",
        type: "number",
      },
      {
        name: "PropiosVentasAP",
        map: "Actual>Propios>VentasAP",
        type: "number",
      },
      {
        name: "PropiosTickets",
        map: "Actual>Propios>Tickets",
        type: "number",
      },
      {
        name: "PropiosTicketsAP",
        map: "Actual>Propios>TicketsAP",
        type: "number",
      },
      {
        name: "TurismoVentas",
        map: "Actual>Turismo>Ventas",
        type: "number",
      },
      {
        name: "TurismoVentasAP",
        map: "Actual>Turismo>VentasAP",
        type: "number",
      },
      {
        name: "TurismoTickets",
        map: "Actual>Turismo>Tickets",
        type: "number",
      },
      {
        name: "TurismoTicketsAP",
        map: "Actual>Turismo>TicketsAP",
        type: "number",
      },
      { name: "LocalesComp_CurrentYear", map: "LastYear>LocalesComp_CurrentYear", type: "number" },
      { name: "LocalesComp_Last", map: "LastYear>LocalesComp_Last", type: "number" },
      { name: "LocalesRepComp_CurrentYear", map: "LastYear>LocalesRepComp_CurrentYear", type: "number" },
      { name: "LocalesRepComp_Last", map: "LastYear>LocalesRepComp_Last", type: "number" },
      { name: "VentasComp_CurrentYear", map: "LastYear>VentasComp_CurrentYear", type: "number" },
      { name: "VentasComp_Last", map: "LastYear>VentasComp_Last", type: "number" },
      { name: "TicketsComp_CurrentYear", map: "LastYear>TicketsComp_CurrentYear", type: "number" },
      { name: "TicketsComp_Last", map: "LastYear>TicketsComp_Last", type: "number" },
      { name: "Del_VentasComp_CurrentYear", map: "LastYear>Del_VentasComp_CurrentYear", type: "number" },
      { name: "Del_VentasComp_Last", map: "LastYear>Del_VentasComp_Last", type: "number" },
      { name: "Taw_VentasComp_CurrentYear", map: "LastYear>Taw_VentasComp_CurrentYear", type: "number" },
      { name: "Taw_VentasComp_Last", map: "LastYear>Taw_VentasComp_Last", type: "number" },
      { name: "Local_VentasComp_CurrentYear", map: "LastYear>Local_VentasComp_CurrentYear", type: "number" },
      { name: "Local_VentasComp_Last", map: "LastYear>Local_VentasComp_Last", type: "number" },
      { name: "Del_TicketsComp_CurrentYear", map: "LastYear>Del_TicketsComp_CurrentYear", type: "number" },
      { name: "Del_TicketsComp_Last", map: "LastYear>Del_TicketsComp_Last", type: "number" },
      { name: "Taw_TicketsComp_CurrentYear", map: "LastYear>Taw_TicketsComp_CurrentYear", type: "number" },
      { name: "Taw_TicketsComp_Last", map: "LastYear>Taw_TicketsComp_Last", type: "number" },
      { name: "Local_TicketsComp_CurrentYear", map: "LastYear>Local_TicketsComp_CurrentYear", type: "number" },
      { name: "Local_TicketsComp_Last", map: "LastYear>Local_TicketsComp_Last", type: "number" },
      { name: "Calle_VentasComp_CurrentYear", map: "LastYear>Calle_VentasComp_CurrentYear", type: "number" },
      { name: "Calle_VentasComp_Last", map: "LastYear>Calle_VentasComp_Last", type: "number" },
      { name: "CC_VentasComp_CurrentYear", map: "LastYear>CC_VentasComp_CurrentYear", type: "number" },
      { name: "CC_VentasComp_Last", map: "LastYear>CC_VentasComp_Last", type: "number" },
      { name: "Conces_VentasComp_CurrentYear", map: "LastYear>Conces_VentasComp_CurrentYear", type: "number" },
      { name: "Conces_VentasComp_Last", map: "LastYear>Conces_VentasComp_Last", type: "number" },
      { name: "Otros_VentasComp_CurrentYear", map: "LastYear>Otros_VentasComp_CurrentYear", type: "number" },
      { name: "Otros_VentasComp_Last", map: "LastYear>Otros_VentasComp_Last", type: "number" },
      { name: "Calle_TicketsComp_CurrentYear", map: "LastYear>Calle_TicketsComp_CurrentYear", type: "number" },
      { name: "Calle_TicketsComp_Last", map: "LastYear>Calle_TicketsComp_Last", type: "number" },
      { name: "CC_TicketsComp_CurrentYear", map: "LastYear>CC_TicketsComp_CurrentYear", type: "number" },
      { name: "CC_TicketsComp_Last", map: "LastYear>CC_TicketsComp_Last", type: "number" },
      { name: "Conces_TicketsComp_CurrentYear", map: "LastYear>Conces_TicketsComp_CurrentYear", type: "number" },
      { name: "Conces_TicketsComp_Last", map: "LastYear>Conces_TicketsComp_Last", type: "number" },
      { name: "Otros_TicketsComp_CurrentYear", map: "LastYear>Otros_TicketsComp_CurrentYear", type: "number" },
      { name: "Otros_TicketsComp_Last", map: "LastYear>Otros_TicketsComp_Last", type: "number" },
      { name: "Z1_VentasComp_CurrentYear", map: "LastYear>Z1_VentasComp_CurrentYear", type: "number" },
      { name: "Z1_VentasComp_Last", map: "LastYear>Z1_VentasComp_Last", type: "number" },
      { name: "Z2_VentasComp_CurrentYear", map: "LastYear>Z2_VentasComp_CurrentYear", type: "number" },
      { name: "Z2_VentasComp_Last", map: "LastYear>Z2_VentasComp_Last", type: "number" },
      { name: "Z3_VentasComp_CurrentYear", map: "LastYear>Z3_VentasComp_CurrentYear", type: "number" },
      { name: "Z3_VentasComp_Last", map: "LastYear>Z3_VentasComp_Last", type: "number" },
      { name: "Z4_VentasComp_CurrentYear", map: "LastYear>Z4_VentasComp_CurrentYear", type: "number" },
      { name: "Z4_VentasComp_Last", map: "LastYear>Z4_VentasComp_Last", type: "number" },
      { name: "Z5_VentasComp_CurrentYear", map: "LastYear>Z5_VentasComp_CurrentYear", type: "number" },
      { name: "Z5_VentasComp_Last", map: "LastYear>Z5_VentasComp_Last", type: "number" },
      { name: "Z6_VentasComp_CurrentYear", map: "LastYear>Z6_VentasComp_CurrentYear", type: "number" },
      { name: "Z6_VentasComp_Last", map: "LastYear>Z6_VentasComp_Last", type: "number" },
      { name: "Z1_TicketsComp_CurrentYear", map: "LastYear>Z1_TicketsComp_CurrentYear", type: "number" },
      { name: "Z1_TicketsComp_Last", map: "LastYear>Z1_TicketsComp_Last", type: "number" },
      { name: "Z2_TicketsComp_CurrentYear", map: "LastYear>Z2_TicketsComp_CurrentYear", type: "number" },
      { name: "Z2_TicketsComp_Last", map: "LastYear>Z2_TicketsComp_Last", type: "number" },
      { name: "Z3_TicketsComp_CurrentYear", map: "LastYear>Z3_TicketsComp_CurrentYear", type: "number" },
      { name: "Z3_TicketsComp_Last", map: "LastYear>Z3_TicketsComp_Last", type: "number" },
      { name: "Z4_TicketsComp_CurrentYear", map: "LastYear>Z4_TicketsComp_CurrentYear", type: "number" },
      { name: "Z4_TicketsComp_Last", map: "LastYear>Z4_TicketsComp_Last", type: "number" },
      { name: "Z5_TicketsComp_CurrentYear", map: "LastYear>Z5_TicketsComp_CurrentYear", type: "number" },
      { name: "Z5_TicketsComp_Last", map: "LastYear>Z5_TicketsComp_Last", type: "number" },
      { name: "Z6_TicketsComp_CurrentYear", map: "LastYear>Z6_TicketsComp_CurrentYear", type: "number" },
      { name: "Z6_TicketsComp_Last", map: "LastYear>Z6_TicketsComp_Last", type: "number" },
      { name: "T1_VentasComp_CurrentYear", map: "LastYear>T1_VentasComp_CurrentYear", type: "number" },
      { name: "T1_VentasComp_Last", map: "LastYear>T1_VentasComp_Last", type: "number" },
      { name: "T2_VentasComp_CurrentYear", map: "LastYear>T2_VentasComp_CurrentYear", type: "number" },
      { name: "T2_VentasComp_Last", map: "LastYear>T2_VentasComp_Last", type: "number" },
      { name: "T3_VentasComp_CurrentYear", map: "LastYear>T3_VentasComp_CurrentYear", type: "number" },
      { name: "T3_VentasComp_Last", map: "LastYear>T3_VentasComp_Last", type: "number" },
      { name: "T4_VentasComp_CurrentYear", map: "LastYear>T4_VentasComp_CurrentYear", type: "number" },
      { name: "T4_VentasComp_Last", map: "LastYear>T4_VentasComp_Last", type: "number" },
      { name: "T5_VentasComp_CurrentYear", map: "LastYear>T5_VentasComp_CurrentYear", type: "number" },
      { name: "T5_VentasComp_Last", map: "LastYear>T5_VentasComp_Last", type: "number" },
      { name: "T6_VentasComp_CurrentYear", map: "LastYear>T6_VentasComp_CurrentYear", type: "number" },
      { name: "T6_VentasComp_Last", map: "LastYear>T6_VentasComp_Last", type: "number" },
      { name: "T1_TicketsComp_CurrentYear", map: "LastYear>T1_TicketsComp_CurrentYear", type: "number" },
      { name: "T1_TicketsComp_Last", map: "LastYear>T1_TicketsComp_Last", type: "number" },
      { name: "T2_TicketsComp_CurrentYear", map: "LastYear>T2_TicketsComp_CurrentYear", type: "number" },
      { name: "T2_TicketsComp_Last", map: "LastYear>T2_TicketsComp_Last", type: "number" },
      { name: "T3_TicketsComp_CurrentYear", map: "LastYear>T3_TicketsComp_CurrentYear", type: "number" },
      { name: "T3_TicketsComp_Last", map: "LastYear>T3_TicketsComp_Last", type: "number" },
      { name: "T4_TicketsComp_CurrentYear", map: "LastYear>T4_TicketsComp_CurrentYear", type: "number" },
      { name: "T4_TicketsComp_Last", map: "LastYear>T4_TicketsComp_Last", type: "number" },
      { name: "T5_TicketsComp_CurrentYear", map: "LastYear>T5_TicketsComp_CurrentYear", type: "number" },
      { name: "T5_TicketsComp_Last", map: "LastYear>T5_TicketsComp_Last", type: "number" },
      { name: "T6_TicketsComp_CurrentYear", map: "LastYear>T6_TicketsComp_CurrentYear", type: "number" },
      { name: "T6_TicketsComp_Last", map: "LastYear>T6_TicketsComp_Last", type: "number" },


    ],
    datatype: "json",
    root: "",
    id: "UUID",
    sortcolumn: "Cadena",
    localdata: modifiedVentasData,
  };

  const [showDataColumns, setShowDataColumns] = useState(false);

  const dataColumns = !showDataColumns
    ? []
    : [
      { text: "VentasBrutoTotales", datafield: "VentasBrutoTotales", type: "number", width: 120 },
      { text: "VentasBrutoCanalDelivery", datafield: "VentasBrutoCanalDelivery", type: "number", width: 120 },
      { text: "VentasBrutoCanalTakeAway", datafield: "VentasBrutoCanalTakeAway", type: "number", width: 120 },
      { text: "VentasBrutoCanalLocal", datafield: "VentasBrutoCanalLocal", type: "number", width: 120 },
      { text: "VentasBrutoUbicacionCalle", datafield: "VentasBrutoUbicacionCalle", type: "number", width: 120 },
      { text: "VentasBrutoUbicacionCC", datafield: "VentasBrutoUbicacionCC", type: "number", width: 120 },
      { text: "VentasBrutoUbicacionConcesiones", datafield: "VentasBrutoUbicacionConcesiones", type: "number", width: 120 },
      { text: "VentasBrutoUbicacionOtros", datafield: "VentasBrutoUbicacionOtros", type: "number", width: 120 },
      { text: "VentasBrutoRegionZ1", datafield: "VentasBrutoRegionZ1", type: "number", width: 120 },
      { text: "VentasBrutoRegionZ2", datafield: "VentasBrutoRegionZ2", type: "number", width: 120 },
      { text: "VentasBrutoRegionZ3", datafield: "VentasBrutoRegionZ3", type: "number", width: 120 },
      { text: "VentasBrutoRegionZ4", datafield: "VentasBrutoRegionZ4", type: "number", width: 120 },
      { text: "VentasBrutoRegionZ5", datafield: "VentasBrutoRegionZ5", type: "number", width: 120 },
      { text: "VentasBrutoRegionZ6", datafield: "VentasBrutoRegionZ6", type: "number", width: 120 },
      { text: "VentasBrutoMomentoT1", datafield: "VentasBrutoMomentoT1", type: "number", width: 120 },
      { text: "VentasBrutoMomentoT2", datafield: "VentasBrutoMomentoT2", type: "number", width: 120 },
      { text: "VentasBrutoMomentoT3", datafield: "VentasBrutoMomentoT3", type: "number", width: 120 },
      { text: "VentasBrutoMomentoT4", datafield: "VentasBrutoMomentoT4", type: "number", width: 120 },
      { text: "VentasBrutoMomentoT5", datafield: "VentasBrutoMomentoT5", type: "number", width: 120 },
      { text: "VentasBrutoMomentoT6", datafield: "VentasBrutoMomentoT6", type: "number", width: 120 },
      { text: "VentasComparableTotales", datafield: "VentasComparableTotales", type: "number", width: 120 },
      { text: "VentasComparableCanalDelivery", datafield: "VentasComparableCanalDelivery", type: "number", width: 120 },
      { text: "VentasComparableCanalTakeAway", datafield: "VentasComparableCanalTakeAway", type: "number", width: 120 },
      { text: "VentasComparableCanalLocal", datafield: "VentasComparableCanalLocal", type: "number", width: 120 },
      { text: "VentasComparableUbicacionCalle", datafield: "VentasComparableUbicacionCalle", type: "number", width: 120 },
      { text: "VentasComparableUbicacionCC", datafield: "VentasComparableUbicacionCC", type: "number", width: 120 },
      { text: "VentasComparableUbicacionConcesiones", datafield: "VentasComparableUbicacionConcesiones", type: "number", width: 120 },
      { text: "VentasComparableUbicacionOtros", datafield: "VentasComparableUbicacionOtros", type: "number", width: 120 },
      { text: "VentasComparableRegionZ1", datafield: "VentasComparableRegionZ1", type: "number", width: 120 },
      { text: "VentasComparableRegionZ2", datafield: "VentasComparableRegionZ2", type: "number", width: 120 },
      { text: "VentasComparableRegionZ3", datafield: "VentasComparableRegionZ3", type: "number", width: 120 },
      { text: "VentasComparableRegionZ4", datafield: "VentasComparableRegionZ4", type: "number", width: 120 },
      { text: "VentasComparableRegionZ5", datafield: "VentasComparableRegionZ5", type: "number", width: 120 },
      { text: "VentasComparableRegionZ6", datafield: "VentasComparableRegionZ6", type: "number", width: 120 },
      { text: "VentasComparableMomentoT1", datafield: "VentasComparableMomentoT1", type: "number", width: 120 },
      { text: "VentasComparableMomentoT2", datafield: "VentasComparableMomentoT2", type: "number", width: 120 },
      { text: "VentasComparableMomentoT3", datafield: "VentasComparableMomentoT3", type: "number", width: 120 },
      { text: "VentasComparableMomentoT4", datafield: "VentasComparableMomentoT4", type: "number", width: 120 },
      { text: "VentasComparableMomentoT5", datafield: "VentasComparableMomentoT5", type: "number", width: 120 },
      { text: "VentasComparableMomentoT6", datafield: "VentasComparableMomentoT6", type: "number", width: 120 },
      { text: "TicketsBrutoTotales", datafield: "TicketsBrutoTotales", type: "number", width: 120 },
      { text: "TicketsBrutoCanalDelivery", datafield: "TicketsBrutoCanalDelivery", type: "number", width: 120 },
      { text: "TicketsBrutoCanalTakeAway", datafield: "TicketsBrutoCanalTakeAway", type: "number", width: 120 },
      { text: "TicketsBrutoCanalLocal", datafield: "TicketsBrutoCanalLocal", type: "number", width: 120 },
      { text: "TicketsBrutoUbicacionCalle", datafield: "TicketsBrutoUbicacionCalle", type: "number", width: 120 },
      { text: "TicketsBrutoUbicacionCC", datafield: "TicketsBrutoUbicacionCC", type: "number", width: 120 },
      { text: "TicketsBrutoUbicacionConcesiones", datafield: "TicketsBrutoUbicacionConcesiones", type: "number", width: 120 },
      { text: "TicketsBrutoUbicacionOtros", datafield: "TicketsBrutoUbicacionOtros", type: "number", width: 120 },
      { text: "TicketsBrutoRegionZ1", datafield: "TicketsBrutoRegionZ1", type: "number", width: 120 },
      { text: "TicketsBrutoRegionZ2", datafield: "TicketsBrutoRegionZ2", type: "number", width: 120 },
      { text: "TicketsBrutoRegionZ3", datafield: "TicketsBrutoRegionZ3", type: "number", width: 120 },
      { text: "TicketsBrutoRegionZ4", datafield: "TicketsBrutoRegionZ4", type: "number", width: 120 },
      { text: "TicketsBrutoRegionZ5", datafield: "TicketsBrutoRegionZ5", type: "number", width: 120 },
      { text: "TicketsBrutoRegionZ6", datafield: "TicketsBrutoRegionZ6", type: "number", width: 120 },
      { text: "TicketsBrutoMomentoT1", datafield: "TicketsBrutoMomentoT1", type: "number", width: 120 },
      { text: "TicketsBrutoMomentoT2", datafield: "TicketsBrutoMomentoT2", type: "number", width: 120 },
      { text: "TicketsBrutoMomentoT3", datafield: "TicketsBrutoMomentoT3", type: "number", width: 120 },
      { text: "TicketsBrutoMomentoT4", datafield: "TicketsBrutoMomentoT4", type: "number", width: 120 },
      { text: "TicketsBrutoMomentoT5", datafield: "TicketsBrutoMomentoT5", type: "number", width: 120 },
      { text: "TicketsBrutoMomentoT6", datafield: "TicketsBrutoMomentoT6", type: "number", width: 120 },
      { text: "TicketsComparableTotales", datafield: "TicketsComparableTotales", type: "number", width: 120 },
      { text: "TicketsComparableCanalDelivery", datafield: "TicketsComparableCanalDelivery", type: "number", width: 120 },
      { text: "TicketsComparableCanalTakeAway", datafield: "TicketsComparableCanalTakeAway", type: "number", width: 120 },
      { text: "TicketsComparableCanalLocal", datafield: "TicketsComparableCanalLocal", type: "number", width: 120 },
      { text: "TicketsComparableUbicacionCalle", datafield: "TicketsComparableUbicacionCalle", type: "number", width: 120 },
      { text: "TicketsComparableUbicacionCC", datafield: "TicketsComparableUbicacionCC", type: "number", width: 120 },
      { text: "TicketsComparableUbicacionConcesiones", datafield: "TicketsComparableUbicacionConcesiones", type: "number", width: 120 },
      { text: "TicketsComparableUbicacionOtros", datafield: "TicketsComparableUbicacionOtros", type: "number", width: 120 },
      { text: "TicketsComparableRegionZ1", datafield: "TicketsComparableRegionZ1", type: "number", width: 120 },
      { text: "TicketsComparableRegionZ2", datafield: "TicketsComparableRegionZ2", type: "number", width: 120 },
      { text: "TicketsComparableRegionZ3", datafield: "TicketsComparableRegionZ3", type: "number", width: 120 },
      { text: "TicketsComparableRegionZ4", datafield: "TicketsComparableRegionZ4", type: "number", width: 120 },
      { text: "TicketsComparableRegionZ5", datafield: "TicketsComparableRegionZ5", type: "number", width: 120 },
      { text: "TicketsComparableRegionZ6", datafield: "TicketsComparableRegionZ6", type: "number", width: 120 },
      { text: "TicketsComparableMomentoT1", datafield: "TicketsComparableMomentoT1", type: "number", width: 120 },
      { text: "TicketsComparableMomentoT2", datafield: "TicketsComparableMomentoT2", type: "number", width: 120 },
      { text: "TicketsComparableMomentoT3", datafield: "TicketsComparableMomentoT3", type: "number", width: 120 },
      { text: "TicketsComparableMomentoT4", datafield: "TicketsComparableMomentoT4", type: "number", width: 120 },
      { text: "TicketsComparableMomentoT5", datafield: "TicketsComparableMomentoT5", type: "number", width: 120 },
      { text: "TicketsComparableMomentoT6", datafield: "TicketsComparableMomentoT6", type: "number", width: 120 },
      { text: "LocalesAperturas", datafield: "LocalesAperturas", type: "number", width: 120 },
      { text: "LocalesCierres", datafield: "LocalesCierres", type: "number", width: 120 },
      { text: "LocalesBrutoTotal", datafield: "LocalesBrutoTotal", type: "number", width: 120 },
      { text: "LocalesBrutoReportan", datafield: "LocalesBrutoReportan", type: "number", width: 120 },
      { text: "LocalesBrutoSelf", datafield: "LocalesBrutoSelf", type: "number", width: 120 },
      { text: "LocalesBrutoDelivery", datafield: "LocalesBrutoDelivery", type: "number", width: 120 },
      { text: "LocalesComparableTotal", datafield: "LocalesComparableTotal", type: "number", width: 120 },
      { text: "LocalesComparableReportan", datafield: "LocalesComparableReportan", type: "number", width: 120 },
      { text: "LocalesBrutoRegionZ1", datafield: "LocalesBrutoRegionZ1", type: "number", width: 120 },
      { text: "LocalesBrutoRegionZ2", datafield: "LocalesBrutoRegionZ2", type: "number", width: 120 },
      { text: "LocalesBrutoRegionZ3", datafield: "LocalesBrutoRegionZ3", type: "number", width: 120 },
      { text: "LocalesBrutoRegionZ4", datafield: "LocalesBrutoRegionZ4", type: "number", width: 120 },
      { text: "LocalesBrutoRegionZ5", datafield: "LocalesBrutoRegionZ5", type: "number", width: 120 },
      { text: "LocalesBrutoRegionZ6", datafield: "LocalesBrutoRegionZ6", type: "number", width: 120 },
      { text: "AgregadoresVentas", datafield: "AgregadoresVentas", type: "number", width: 120 },
      { text: "AgregadoresVentasAP", datafield: "AgregadoresVentasAP", type: "number", width: 120 },
      { text: "AgregadoresTickets", datafield: "AgregadoresTickets", type: "number", width: 120 },
      { text: "AgregadoresTicketsAP", datafield: "AgregadoresTicketsAP", type: "number", width: 120 },
      { text: "PropiosVentas", datafield: "PropiosVentas", type: "number", width: 120 },
      { text: "PropiosVentasAP", datafield: "PropiosVentasAP", type: "number", width: 120 },
      { text: "PropiosTickets", datafield: "PropiosTickets", type: "number", width: 120 },
      { text: "PropiosTicketsAP", datafield: "PropiosTicketsAP", type: "number", width: 120 },
      { text: "TurismoVentas", datafield: "TurismoVentas", type: "number", width: 120 },
      { text: "TurismoVentasAP", datafield: "TurismoVentasAP", type: "number", width: 120 },
      { text: "TurismoTickets", datafield: "TurismoTickets", type: "number", width: 120 },
      { text: "TurismoTicketsAP", datafield: "TurismoTicketsAP", type: "number", width: 120 },
      { text: "VentasComparables", datafield: "VentasComparables", type: "number", width: 120 },
      { text: "TicketsComparables", datafield: "TicketsComparables", type: "number", width: 120 },
      { text: "LocalesComparables", datafield: "LocalesComparables", type: "number", width: 120 },
      { text: "LocalesRepComparables", datafield: "LocalesRepComparables", type: "number", width: 120 },
      { text: "VentasComp_CurrentYear", datafield: "VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "VentasComp_Last", datafield: "VentasComp_Last", type: "number", width: 120 },
      { text: "TicketsComp_CurrentYear", datafield: "TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "TicketsComp_Last", datafield: "TicketsComp_Last", type: "number", width: 120 },
      { text: "LocalesComp_CurrentYear", datafield: "LocalesComp_CurrentYear", type: "number", width: 120 },
      { text: "LocalesComp_Last", datafield: "LocalesComp_Last", type: "number", width: 120 },
      { text: "LocalesRepComp_CurrentYear", datafield: "LocalesRepComp_CurrentYear", type: "number", width: 120 },
      { text: "LocalesRepComp_Last", datafield: "LocalesRepComp_Last", type: "number", width: 120 },
      { text: "Del_VentasComp_CurrentYear", datafield: "Del_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "Del_VentasComp_Last", datafield: "Del_VentasComp_Last", type: "number", width: 120 },
      { text: "Taw_VentasComp_CurrentYear", datafield: "Taw_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "Taw_VentasComp_Last", datafield: "Taw_VentasComp_Last", type: "number", width: 120 },
      { text: "Local_VentasComp_CurrentYear", datafield: "Local_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "Local_VentasComp_Last", datafield: "Local_VentasComp_Last", type: "number", width: 120 },
      { text: "Del_TicketsComp_CurrentYear", datafield: "Del_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "Del_TicketsComp_Last", datafield: "Del_TicketsComp_Last", type: "number", width: 120 },
      { text: "Taw_TicketsComp_CurrentYear", datafield: "Taw_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "Taw_TicketsComp_Last", datafield: "Taw_TicketsComp_Last", type: "number", width: 120 },
      { text: "Local_TicketsComp_CurrentYear", datafield: "Local_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "Local_TicketsComp_Last", datafield: "Local_TicketsComp_Last", type: "number", width: 120 },
      { text: "Calle_VentasComp_CurrentYear", datafield: "Calle_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "Calle_VentasComp_Last", datafield: "Calle_VentasComp_Last", type: "number", width: 120 },
      { text: "CC_VentasComp_CurrentYear", datafield: "CC_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "CC_VentasComp_Last", datafield: "CC_VentasComp_Last", type: "number", width: 120 },
      { text: "Conces_VentasComp_CurrentYear", datafield: "Conces_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "Conces_VentasComp_Last", datafield: "Conces_VentasComp_Last", type: "number", width: 120 },
      { text: "Otros_VentasComp_CurrentYear", datafield: "Otros_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "Otros_VentasComp_Last", datafield: "Otros_VentasComp_Last", type: "number", width: 120 },
      { text: "Calle_TicketsComp_CurrentYear", datafield: "Calle_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "Calle_TicketsComp_Last", datafield: "Calle_TicketsComp_Last", type: "number", width: 120 },
      { text: "CC_TicketsComp_CurrentYear", datafield: "CC_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "CC_TicketsComp_Last", datafield: "CC_TicketsComp_Last", type: "number", width: 120 },
      { text: "Conces_TicketsComp_CurrentYear", datafield: "Conces_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "Conces_TicketsComp_Last", datafield: "Conces_TicketsComp_Last", type: "number", width: 120 },
      { text: "Otros_TicketsComp_CurrentYear", datafield: "Otros_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "Otros_TicketsComp_Last", datafield: "Otros_TicketsComp_Last", type: "number", width: 120 },
      { text: "Z1_VentasComp_CurrentYear", datafield: "Z1_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "Z1_VentasComp_Last", datafield: "Z1_VentasComp_Last", type: "number", width: 120 },
      { text: "Z2_VentasComp_CurrentYear", datafield: "Z2_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "Z2_VentasComp_Last", datafield: "Z2_VentasComp_Last", type: "number", width: 120 },
      { text: "Z3_VentasComp_CurrentYear", datafield: "Z3_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "Z3_VentasComp_Last", datafield: "Z3_VentasComp_Last", type: "number", width: 120 },
      { text: "Z4_VentasComp_CurrentYear", datafield: "Z4_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "Z4_VentasComp_Last", datafield: "Z4_VentasComp_Last", type: "number", width: 120 },
      { text: "Z5_VentasComp_CurrentYear", datafield: "Z5_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "Z5_VentasComp_Last", datafield: "Z5_VentasComp_Last", type: "number", width: 120 },
      { text: "Z6_VentasComp_CurrentYear", datafield: "Z6_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "Z6_VentasComp_Last", datafield: "Z6_VentasComp_Last", type: "number", width: 120 },
      { text: "Z1_TicketsComp_CurrentYear", datafield: "Z1_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "Z1_TicketsComp_Last", datafield: "Z1_TicketsComp_Last", type: "number", width: 120 },
      { text: "Z2_TicketsComp_CurrentYear", datafield: "Z2_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "Z2_TicketsComp_Last", datafield: "Z2_TicketsComp_Last", type: "number", width: 120 },
      { text: "Z3_TicketsComp_CurrentYear", datafield: "Z3_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "Z3_TicketsComp_Last", datafield: "Z3_TicketsComp_Last", type: "number", width: 120 },
      { text: "Z4_TicketsComp_CurrentYear", datafield: "Z4_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "Z4_TicketsComp_Last", datafield: "Z4_TicketsComp_Last", type: "number", width: 120 },
      { text: "Z5_TicketsComp_CurrentYear", datafield: "Z5_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "Z5_TicketsComp_Last", datafield: "Z5_TicketsComp_Last", type: "number", width: 120 },
      { text: "Z6_TicketsComp_CurrentYear", datafield: "Z6_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "Z6_TicketsComp_Last", datafield: "Z6_TicketsComp_Last", type: "number", width: 120 },
      { text: "T1_VentasComp_CurrentYear", datafield: "T1_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "T1_VentasComp_Last", datafield: "T1_VentasComp_Last", type: "number", width: 120 },
      { text: "T2_VentasComp_CurrentYear", datafield: "T2_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "T2_VentasComp_Last", datafield: "T2_VentasComp_Last", type: "number", width: 120 },
      { text: "T3_VentasComp_CurrentYear", datafield: "T3_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "T3_VentasComp_Last", datafield: "T3_VentasComp_Last", type: "number", width: 120 },
      { text: "T4_VentasComp_CurrentYear", datafield: "T4_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "T4_VentasComp_Last", datafield: "T4_VentasComp_Last", type: "number", width: 120 },
      { text: "T5_VentasComp_CurrentYear", datafield: "T5_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "T5_VentasComp_Last", datafield: "T5_VentasComp_Last", type: "number", width: 120 },
      { text: "T6_VentasComp_CurrentYear", datafield: "T6_VentasComp_CurrentYear", type: "number", width: 120 },
      { text: "T6_VentasComp_Last", datafield: "T6_VentasComp_Last", type: "number", width: 120 },
      { text: "T1_TicketsComp_CurrentYear", datafield: "T1_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "T1_TicketsComp_Last", datafield: "T1_TicketsComp_Last", type: "number", width: 120 },
      { text: "T2_TicketsComp_CurrentYear", datafield: "T2_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "T2_TicketsComp_Last", datafield: "T2_TicketsComp_Last", type: "number", width: 120 },
      { text: "T3_TicketsComp_CurrentYear", datafield: "T3_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "T3_TicketsComp_Last", datafield: "T3_TicketsComp_Last", type: "number", width: 120 },
      { text: "T4_TicketsComp_CurrentYear", datafield: "T4_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "T4_TicketsComp_Last", datafield: "T4_TicketsComp_Last", type: "number", width: 120 },
      { text: "T5_TicketsComp_CurrentYear", datafield: "T5_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "T5_TicketsComp_Last", datafield: "T5_TicketsComp_Last", type: "number", width: 120 },
      { text: "T6_TicketsComp_CurrentYear", datafield: "T6_TicketsComp_CurrentYear", type: "number", width: 120 },
      { text: "T6_TicketsComp_Last", datafield: "T6_TicketsComp_Last", type: "number", width: 120 },
    ];

  const columns = [
    { text: "Cadena", datafield: "Cadena", width: 120 },
    {
      text: "Segmento",
      datafield: "Segmento",
      width: 120,
      cellsRenderer: (_r: any, _c: any, val: any) => {
        return normalize(val[0]?.Descripcion);
      },
    },
    { text: "Semana", datafield: "Semana", width: 110 },
    { text: "Año", datafield: "Anyo", width: 80 },
    { text: "Ratio", datafield: "Ratio", width: 80 },
    {
      text: "Modelización",
      datafield: "Modelizacion",
      exportable: false,
      cellsRenderer: (_r: any, _c: any, val: any) => {
        return normalize(normalizeStr[val + 1]);
      },
    },
    ...dataColumns,
  ];

  const dropdownStyles: Partial<IDropdownStyles> = {
    root: { display: "flex", alignSelf: "center", marginLeft: "6px" },
    label: {
      color: "var(--primary-color)",
      fontWeight: 400,
      padding: "7px 0px",
      fontSize: "13px",
      margin: "0px 6px 0px 0px",
    },
    title: {
      borderColor: "transparent",
      transition: "background 0.3s",
    },
    dropdown: {
      selectors: {
        "&:hover .ms-Dropdown-title, &:active .ms-Dropdown-title": {
          borderColor: "transparent",
          background: "#f3f2f1",
        },
        ":focus::after": {
          border: "1px solid transparent",
        },
      },
    },
    callout: {
      minWidth: 130,
    },
  };
  const stackTokens: IStackTokens = { childrenGap: 10 };

  let weekOpts: IDropdownOption[] = [{ key: 0, text: "Todas" }];
  let yearOpts: IDropdownOption[] = [];
  //let cadsOpts:IDropdownOption[] = []

  const [cadsOpts, setCadsOpts] = useState<IDropdownOption[]>([]);

  useQuery(CADENAS, {
    onCompleted: (qry) => {
      if (qry.getCadena) {
        let cads: IDropdownOption[] = [];
        let tmpCadenas = JSON.parse(JSON.stringify(qry.getCadena)).sort(
          (a: any, b: any) => a.Nombre.localeCompare(b.Nombre)
        );
        tmpCadenas.forEach((cad: any) => {
          cads.push({
            key: cad.Nombre,
            text: `${cad.Nombre}${cad.hasVentas ? "" : "*"}`,
          });
        });
        setCadsOpts(cads);
      }
    },
  });

  const WEEK_QUERY = gql`
    query ($year: Int!) {
      getWeekVisibility(Anyo: $year)
    }
  `;

  let qry = useQuery(WEEK_QUERY, {
    variables: {
      year: parseInt(selectedYear?.text ?? "2019"),
    },
  });

  useEffect(() => {
    if (!!qry.data?.getWeekVisibility) {
      let maxWeek = Math.max(
        ...qry.data?.getWeekVisibility.map((wk: any) => wk.Semana)
      );
      for (let week = semanasDatos[0].week; week <= maxWeek; week++) {
        // FIX ERA, vamos a evitar que semana 1 entre
        if (week !== 1) {
          weekOpts.push({ key: week, text: `${week - 1}` }); // FIX ERA WEEK 1
        }
      }
    }
  }, [yearOpts, semanasDatos, qry.data?.getWeekVisibility, weekOpts]);

  yearOpts = [
    { key: 2019, text: "2019" },
    { key: 2020, text: "2020" },
    { key: 2021, text: "2021" },
    { key: 2022, text: "2022" },
    { key: 2023, text: "2023" },
    { key: 2024, text: "2024" },
    { key: 2025, text: "2025" },
    { key: 2026, text: "2026" },
  ];
  /*
	useEffect(()=>{
		if(qry.data?.getWeekVisibility){
			let weekArray = qry.data?.getWeekVisibility.map((wk:any)=>wk.Semana)
			weekOpts=[]
			for(let week=Math.min(...weekArray); week<=Math.max(...weekArray); week++){
				weekOpts.push({ key: week, text: `${week}` })
			}
			console.log(weekOpts)
		}

	},[qry.data])
	*/

  const changeWeek = (_: any, item: any) => {
    setSelectedWeek(item?.key === 0 ? null : item);
  };
  const changeYear = (_: any, item: any) => {
    setSelectedYear(item);
  };
  const changeCadena = (_: any, item: any) => {
    setSelectedCadena(item?.selected === false ? null : item);
  };

  // Change in every item of ventasData the value of semana to semana -1

  const [getData, { loading }] = useLazyQuery(VENTAS_QRY, {
    fetchPolicy: "no-cache",
    onCompleted: (fetchedData) => {
      const data: any[] = [];
      fetchedData.getVenta.forEach((venta: IVenta) => {
        let v = {
          segmento: venta.Cadena?.Segmento?.[0]?.Descripcion ?? "",
          cadena: venta.Cadena?.Nombre ?? "",
          semana: venta.Semana,
          anyo: venta.Anyo,
          locales_comp: venta.Actual.Locales.Comparable.Total,
          locales_comp_last_year: venta.LastYear?.LocalesComparables ?? 0,
          localesrep_comp: venta.Actual.Locales.Comparable.Reportan,
          localesrep_comp_last_year: venta.LastYear?.LocalesRepComparables ?? 0,
          ventas_comp: venta.Actual.Ventas.Comparable.Totales,
          ventas_comp_last_year: venta.LastYear?.VentasComparables ?? 0,
          //ventas_comp_ap: venta.Anterior.Ventas.Comparables,
          tickets_comp: venta.Actual.Tickets.Comparable.Totales,
          tickets_comp_last_year: venta.LastYear?.TicketsComparables ?? 0,
          //tickets_comp_ap: venta.Anterior.Tickets.Comparables,
          locales_aperturas: venta.Actual.Locales.Aperturas,
          locales_cierres: venta.Actual.Locales.Cierres,
          locales: venta.Actual.Locales.Bruto.Total,
          localesrep: venta.Actual.Locales.Bruto.Reportan,
          ventas: venta.Actual.Ventas.Bruto.Totales,
          //ventas_ap: venta.Anterior.Ventas.Totales,
          tickets: venta.Actual.Tickets.Bruto.Totales,
          //tickets_ap: venta.Anterior.Tickets.Totales,
          del_ventas: venta.Actual.Ventas.Bruto.Canal.Delivery,
          //del_ventas_ap: venta.Anterior.Ventas.Delivery,
          del_tickets: venta.Actual.Tickets.Bruto.Canal.Delivery,
          //del_tickets_ap: venta.Anterior.Tickets.Delivery,
          del_locales: venta.Actual.Locales.Bruto.Delivery,
          //del_locales_ap: venta.LocalesReportanDelivery,
          taw_ventas: venta.Actual.Ventas.Bruto.Canal.TakeAway,
          //taw_ventas_ap: venta.Anterior.Ventas.TakeAway,
          taw_tickets: venta.Actual.Tickets.Bruto.Canal.TakeAway,
          //taw_tickets_ap: venta.Anterior.Tickets.TakeAway,
          local_ventas: venta.Actual.Ventas.Bruto.Canal.Local,
          //local_ventas_ap: venta.Anterior.Ventas.Local,
          local_tickets: venta.Actual.Tickets.Bruto.Canal.Local,
          //local_tickets_ap: venta.Anterior.Tickets.Local,
          calle_ventas: venta.Actual.Ventas.Bruto.Ubicacion.Calle,
          //calle_ventas_ap: venta.Anterior.Ventas.Calle,
          calle_tickets: venta.Actual.Tickets.Bruto.Ubicacion.Calle,
          //calle_tickets_ap: venta.Anterior.Tickets.Calle,
          cc_ventas: venta.Actual.Ventas.Bruto.Ubicacion.CC,
          //cc_ventas_ap: venta.Anterior.Ventas.CC,
          cc_tickets: venta.Actual.Tickets.Bruto.Ubicacion.CC,
          //cc_tickets_ap: venta.Anterior.Tickets.CC,
          conces_ventas: venta.Actual.Ventas.Bruto.Ubicacion.Concesiones,
          //conces_ventas_ap: venta.Anterior.Ventas.Concesiones,
          conces_tickets: venta.Actual.Tickets.Bruto.Ubicacion.Concesiones,
          //conces_tickets_ap: venta.Anterior.Tickets.Concesiones,
          otros_ventas: venta.Actual.Ventas.Bruto.Ubicacion.Otros,
          //otros_ventas_ap: venta.Anterior.Ventas.Otros,
          otros_tickets: venta.Actual.Tickets.Bruto.Ubicacion.Otros,
          //otros_tickets_ap: venta.Anterior.Tickets.Otros,
          z1_ventas: venta.Actual.Ventas.Bruto.Region.Z1,
          //z1_ventas_ap: venta.Anterior.Ventas.Bruto.Region.Z1,
          z1_tickets: venta.Actual.Tickets.Bruto.Region.Z1,
          //z1_tickets_ap: venta.Anterior.Tickets.Bruto.Region.Z1,
          z2_ventas: venta.Actual.Ventas.Bruto.Region.Z2,
          //z2_ventas_ap: venta.Anterior.Ventas.Bruto.Region.Z2,
          z2_tickets: venta.Actual.Tickets.Bruto.Region.Z2,
          //z2_tickets_ap: venta.Anterior.Tickets.Bruto.Region.Z2,
          z3_ventas: venta.Actual.Ventas.Bruto.Region.Z3,
          //z3_ventas_ap: venta.Anterior.Ventas.Bruto.Region.Z3,
          z3_tickets: venta.Actual.Tickets.Bruto.Region.Z3,
          //z3_tickets_ap: venta.Anterior.Tickets.Bruto.Region.Z3,
          z4_ventas: venta.Actual.Ventas.Bruto.Region.Z4,
          //z4_ventas_ap: venta.Anterior.Ventas.Bruto.Region.Z4,
          z4_tickets: venta.Actual.Tickets.Bruto.Region.Z4,
          //z4_tickets_ap: venta.Anterior.Tickets.Bruto.Region.Z4,
          z5_ventas: venta.Actual.Ventas.Bruto.Region.Z5,
          //z5_ventas_ap: venta.Anterior.Ventas.Bruto.Region.Z5,
          z5_tickets: venta.Actual.Tickets.Bruto.Region.Z5,
          //z5_tickets_ap: venta.Anterior.Tickets.Bruto.Region.Z5,
          z6_ventas: venta.Actual.Ventas.Bruto.Region.Z6,
          //z6_ventas_ap: venta.Anterior.Ventas.Bruto.Region.Z6,
          z6_tickets: venta.Actual.Tickets.Bruto.Region.Z6,
          //z6_tickets_ap: venta.Anterior.Tickets.Bruto.Region.Z6,
          t1_ventas: venta.Actual.Ventas.Bruto.Momento.T1,
          //t1_ventas_ap: venta.Anterior.Ventas.Dia.Total,
          t1_tickets: venta.Actual.Tickets.Bruto.Momento.T1,
          //t1_tickets_ap: venta.Anterior.Tickets.Dia.Total,
          t2_ventas: venta.Actual.Ventas.Bruto.Momento.T2,
          //t2_ventas_ap: venta.Anterior.Ventas.Noche.Total,
          t2_tickets: venta.Actual.Tickets.Bruto.Momento.T2,
          //t2_tickets_ap: venta.Anterior.Tickets.Noche.Total,
          t3_ventas: venta.Actual.Ventas.Bruto.Momento.T3,
          //t3_ventas_ap: venta.Anterior.Ventas.Dia.Laborables,
          t3_tickets: venta.Actual.Tickets.Bruto.Momento.T3,
          //t3_tickets_ap: venta.Anterior.Tickets.Dia.Laborables,
          t4_ventas: venta.Actual.Ventas.Bruto.Momento.T4,
          //t4_ventas_ap: venta.Anterior.Ventas.Noche.Laborables,
          t4_tickets: venta.Actual.Tickets.Bruto.Momento.T4,
          //t4_tickets_ap: venta.Anterior.Tickets.Noche.Laborables,
          t5_ventas: venta.Actual.Ventas.Bruto.Momento.T5,
          //t5_ventas_ap: venta.Anterior.Ventas.Dia.Findes,
          t5_tickets: venta.Actual.Tickets.Bruto.Momento.T5,
          //t5_tickets_ap: venta.Anterior.Tickets.Dia.Findes,
          t6_ventas: venta.Actual.Ventas.Bruto.Momento.T6,
          //t6_ventas_ap: venta.Anterior.Ventas.Noche.Findes,
          t6_tickets: venta.Actual.Tickets.Bruto.Momento.T6,
          //t6_tickets_ap: venta.Anterior.Tickets.Noche.Findes,
          ratio: venta.Ratio,
          // COMPARABLES
          del_ventas_comp: venta.Actual.Ventas.Comparable.Canal.Delivery,
          //del_ventas_ap: venta.Anterior.Ventas.Delivery,
          del_tickets_comp: venta.Actual.Tickets.Comparable.Canal.Delivery,
          //del_locales_ap: venta.LocalesReportanDelivery,
          taw_ventas_comp: venta.Actual.Ventas.Comparable.Canal.TakeAway,
          //taw_ventas_ap: venta.Anterior.Ventas.TakeAway,
          taw_tickets_comp: venta.Actual.Tickets.Comparable.Canal.TakeAway,
          //taw_tickets_ap: venta.Anterior.Tickets.TakeAway,
          local_ventas_comp: venta.Actual.Ventas.Comparable.Canal.Local,
          //local_ventas_ap: venta.Anterior.Ventas.Local,
          local_tickets_comp: venta.Actual.Tickets.Comparable.Canal.Local,
          //local_tickets_ap: venta.Anterior.Tickets.Local,
          calle_ventas_comp: venta.Actual.Ventas.Comparable.Ubicacion.Calle,
          //calle_ventas_ap: venta.Anterior.Ventas.Calle,
          calle_tickets_comp: venta.Actual.Tickets.Comparable.Ubicacion.Calle,
          //calle_tickets_ap: venta.Anterior.Tickets.Calle,
          cc_ventas_comp: venta.Actual.Ventas.Comparable.Ubicacion.CC,
          //cc_ventas_ap: venta.Anterior.Ventas.CC,
          cc_tickets_comp: venta.Actual.Tickets.Comparable.Ubicacion.CC,
          //cc_tickets_ap: venta.Anterior.Tickets.CC,
          conces_ventas_comp:
            venta.Actual.Ventas.Comparable.Ubicacion.Concesiones,
          //conces_ventas_ap: venta.Anterior.Ventas.Concesiones,
          conces_tickets_comp:
            venta.Actual.Tickets.Comparable.Ubicacion.Concesiones,
          //conces_tickets_ap: venta.Anterior.Tickets.Concesiones,
          otros_ventas_comp: venta.Actual.Ventas.Comparable.Ubicacion.Otros,
          //otros_ventas_ap: venta.Anterior.Ventas.Otros,
          otros_tickets_comp: venta.Actual.Tickets.Comparable.Ubicacion.Otros,
          //otros_tickets_ap: venta.Anterior.Tickets.Otros,
          z1_ventas_comp: venta.Actual.Ventas.Comparable.Region.Z1,
          //z1_ventas_ap: venta.Anterior.Ventas.Bruto.Region.Z1,
          z1_tickets_comp: venta.Actual.Tickets.Comparable.Region.Z1,
          //z1_tickets_ap: venta.Anterior.Tickets.Bruto.Region.Z1,
          z2_ventas_comp: venta.Actual.Ventas.Comparable.Region.Z2,
          //z2_ventas_ap: venta.Anterior.Ventas.Bruto.Region.Z2,
          z2_tickets_comp: venta.Actual.Tickets.Comparable.Region.Z2,
          //z2_tickets_ap: venta.Anterior.Tickets.Bruto.Region.Z2,
          z3_ventas_comp: venta.Actual.Ventas.Comparable.Region.Z3,
          //z3_ventas_ap: venta.Anterior.Ventas.Bruto.Region.Z3,
          z3_tickets_comp: venta.Actual.Tickets.Comparable.Region.Z3,
          //z3_tickets_ap: venta.Anterior.Tickets.Bruto.Region.Z3,
          z4_ventas_comp: venta.Actual.Ventas.Comparable.Region.Z4,
          //z4_ventas_ap: venta.Anterior.Ventas.Bruto.Region.Z4,
          z4_tickets_comp: venta.Actual.Tickets.Comparable.Region.Z4,
          //z4_tickets_ap: venta.Anterior.Tickets.Bruto.Region.Z4,
          z5_ventas_comp: venta.Actual.Ventas.Comparable.Region.Z5,
          //z5_ventas_ap: venta.Anterior.Ventas.Bruto.Region.Z5,
          z5_tickets_comp: venta.Actual.Tickets.Comparable.Region.Z5,
          //z5_tickets_ap: venta.Anterior.Tickets.Bruto.Region.Z5,
          z6_ventas_comp: venta.Actual.Ventas.Comparable.Region.Z6,
          //z6_ventas_ap: venta.Anterior.Ventas.Bruto.Region.Z6,
          z6_tickets_comp: venta.Actual.Tickets.Comparable.Region.Z6,
          //z6_tickets_ap: venta.Anterior.Tickets.Bruto.Region.Z6,
          t1_ventas_comp: venta.Actual.Ventas.Comparable.Momento.T1,
          //t1_ventas_ap: venta.Anterior.Ventas.Dia.Total,
          t1_tickets_comp: venta.Actual.Tickets.Comparable.Momento.T1,
          //t1_tickets_ap: venta.Anterior.Tickets.Dia.Total,
          t2_ventas_comp: venta.Actual.Ventas.Comparable.Momento.T2,
          //t2_ventas_ap: venta.Anterior.Ventas.Noche.Total,
          t2_tickets_comp: venta.Actual.Tickets.Comparable.Momento.T2,
          //t2_tickets_ap: venta.Anterior.Tickets.Noche.Total,
          t3_ventas_comp: venta.Actual.Ventas.Comparable.Momento.T3,
          //t3_ventas_ap: venta.Anterior.Ventas.Dia.Laborables,
          t3_tickets_comp: venta.Actual.Tickets.Comparable.Momento.T3,
          //t3_tickets_ap: venta.Anterior.Tickets.Dia.Laborables,
          t4_ventas_comp: venta.Actual.Ventas.Comparable.Momento.T4,
          //t4_ventas_ap: venta.Anterior.Ventas.Noche.Laborables,
          t4_tickets_comp: venta.Actual.Tickets.Comparable.Momento.T4,
          //t4_tickets_ap: venta.Anterior.Tickets.Noche.Laborables,
          t5_ventas_comp: venta.Actual.Ventas.Comparable.Momento.T5,
          //t5_ventas_ap: venta.Anterior.Ventas.Dia.Findes,
          t5_tickets_comp: venta.Actual.Tickets.Comparable.Momento.T5,
          //t5_tickets_ap: venta.Anterior.Tickets.Dia.Findes,
          t6_ventas_comp: venta.Actual.Ventas.Comparable.Momento.T6,
          //t6_ventas_ap: venta.Anterior.Ventas.Noche.Findes,
          t6_tickets_comp: venta.Actual.Tickets.Comparable.Momento.T6,
          //t6_tickets_ap: venta.Anterior.Tickets.Noche.Findes,
          z1_locales: venta.Actual.Locales.Bruto.Region?.Z1 || 0,
        z2_locales: venta.Actual.Locales.Bruto.Region?.Z2 || 0,
        z3_locales: venta.Actual.Locales.Bruto.Region?.Z3 || 0,
        z4_locales: venta.Actual.Locales.Bruto.Region?.Z4 || 0,
        z5_locales: venta.Actual.Locales.Bruto.Region?.Z5 || 0,
        z6_locales: venta.Actual.Locales.Bruto.Region?.Z6 || 0,
        
        agregadores_ventas: venta.Actual.Agregadores?.Ventas || 0,
        agregadores_ventasAP: venta.Actual.Agregadores?.VentasAP || 0,
        agregadores_tickets: venta.Actual.Agregadores?.Tickets || 0,
        agregadores_ticketsAP: venta.Actual.Agregadores?.TicketsAP || 0,
        propios_ventas: venta.Actual.Propios?.Ventas || 0,
        propios_ventasAP: venta.Actual.Propios?.VentasAP || 0,
        propios_tickets: venta.Actual.Propios?.Tickets || 0,
        propios_ticketsAP: venta.Actual.Propios?.TicketsAP || 0,
        turismo_ventas: venta.Actual.Turismo?.Ventas || 0,
        turismo_ventasAP: venta.Actual.Turismo?.VentasAP || 0,
        turismo_tickets: venta.Actual.Turismo?.Tickets || 0,
        turismo_ticketsAP: venta.Actual.Turismo?.TicketsAP || 0,
        // COMPARABLES
        locales_comp_current: venta.LastYear?.LocalesComp_CurrentYear ?? 0,
        locales_comp_last: venta.LastYear?.LocalesComp_Last ?? 0,
        
        localesRep_comp_current: venta.LastYear?.LocalesRepComp_CurrentYear ?? 0,
        localesRep_comp_last: venta.LastYear?.LocalesRepComp_Last ?? 0,

        ventas_comp_current: venta.LastYear?.VentasComp_CurrentYear ?? 0,
        ventas_comp_last: venta.LastYear?.VentasComp_Last ?? 0,

        tickets_comp_current: venta.LastYear?.TicketsComp_CurrentYear ?? 0,
        tickets_comp_last: venta.LastYear?.TicketsComp_Last ?? 0,

        del_ventas_comp_current: venta.LastYear?.Del_VentasComp_CurrentYear ?? 0,
        del_ventas_comp_last: venta.LastYear?.Del_VentasComp_Last ?? 0,
        del_tickets_comp_current: venta.LastYear?.Del_TicketsComp_CurrentYear ?? 0,
        del_tickets_comp_last: venta.LastYear?.Del_TicketsComp_Last ?? 0,

        taw_ventas_comp_current: venta.LastYear?.Taw_VentasComp_CurrentYear ?? 0,
        taw_ventas_comp_last: venta.LastYear?.Taw_VentasComp_Last ?? 0,
        taw_tickets_comp_current: venta.LastYear?.Taw_TicketsComp_CurrentYear ?? 0,
        taw_tickets_comp_last: venta.LastYear?.Taw_TicketsComp_Last ?? 0,

        local_ventas_comp_current: venta.LastYear?.Local_VentasComp_CurrentYear ?? 0,
        local_ventas_comp_last: venta.LastYear?.Local_VentasComp_Last ?? 0,
        local_tickets_comp_current: venta.LastYear?.Local_TicketsComp_CurrentYear ?? 0,
        local_tickets_comp_last: venta.LastYear?.Local_TicketsComp_Last ?? 0,

        calle_ventas_comp_current: venta.LastYear?.Calle_VentasComp_CurrentYear ?? 0,
        calle_ventas_comp_last: venta.LastYear?.Calle_VentasComp_Last ?? 0,
        calle_tickets_comp_current: venta.LastYear?.Calle_TicketsComp_CurrentYear ?? 0,
        calle_tickets_comp_last: venta.LastYear?.Calle_TicketsComp_Last ?? 0,

        cc_ventas_comp_current: venta.LastYear?.CC_VentasComp_CurrentYear ?? 0,
        cc_ventas_comp_last: venta.LastYear?.CC_VentasComp_Last ?? 0,
        cc_tickets_comp_current: venta.LastYear?.CC_TicketsComp_CurrentYear ?? 0,
        cc_tickets_comp_last: venta.LastYear?.CC_TicketsComp_Last ?? 0,

        conces_ventas_comp_current: venta.LastYear?.Conces_VentasComp_CurrentYear ?? 0,
        conces_ventas_comp_last: venta.LastYear?.Conces_VentasComp_Last ?? 0,
        conces_tickets_comp_current: venta.LastYear?.Conces_TicketsComp_CurrentYear ?? 0,
        conces_tickets_comp_last: venta.LastYear?.Conces_TicketsComp_Last ?? 0,

        otros_ventas_comp_current: venta.LastYear?.Otros_VentasComp_CurrentYear ?? 0,
        otros_ventas_comp_last: venta.LastYear?.Otros_VentasComp_Last ?? 0,
        otros_tickets_comp_current: venta.LastYear?.Otros_TicketsComp_CurrentYear ?? 0,
        otros_tickets_comp_last: venta.LastYear?.Otros_TicketsComp_Last ?? 0,

        z1_ventas_comp_current: venta.LastYear?.Z1_VentasComp_CurrentYear ?? 0,
        z1_ventas_comp_last: venta.LastYear?.Z1_VentasComp_Last ?? 0,
        z1_tickets_comp_current: venta.LastYear?.Z1_TicketsComp_CurrentYear ?? 0,
        z1_tickets_comp_last: venta.LastYear?.Z1_TicketsComp_Last ?? 0,

        z2_ventas_comp_current: venta.LastYear?.Z2_VentasComp_CurrentYear ?? 0,
        z2_ventas_comp_last: venta.LastYear?.Z2_VentasComp_Last ?? 0,
        z2_tickets_comp_current: venta.LastYear?.Z2_TicketsComp_CurrentYear ?? 0,
        z2_tickets_comp_last: venta.LastYear?.Z2_TicketsComp_Last ?? 0,

        z3_ventas_comp_current: venta.LastYear?.Z3_VentasComp_CurrentYear ?? 0,
        z3_ventas_comp_last: venta.LastYear?.Z3_VentasComp_Last ?? 0,
        z3_tickets_comp_current: venta.LastYear?.Z3_TicketsComp_CurrentYear ?? 0,
        z3_tickets_comp_last: venta.LastYear?.Z3_TicketsComp_Last ?? 0,

        z4_ventas_comp_current: venta.LastYear?.Z4_VentasComp_CurrentYear ?? 0,
        z4_ventas_comp_last: venta.LastYear?.Z4_VentasComp_Last ?? 0,
        z4_tickets_comp_current: venta.LastYear?.Z4_TicketsComp_CurrentYear ?? 0,
        z4_tickets_comp_last: venta.LastYear?.Z4_TicketsComp_Last ?? 0,

        z5_ventas_comp_current: venta.LastYear?.Z5_VentasComp_CurrentYear ?? 0,
        z5_ventas_comp_last: venta.LastYear?.Z5_VentasComp_Last ?? 0,
        z5_tickets_comp_current: venta.LastYear?.Z5_TicketsComp_CurrentYear ?? 0,
        z5_tickets_comp_last: venta.LastYear?.Z5_TicketsComp_Last ?? 0,

        z6_ventas_comp_current: venta.LastYear?.Z6_VentasComp_CurrentYear ?? 0,
        z6_ventas_comp_last: venta.LastYear?.Z6_VentasComp_Last ?? 0,
        z6_tickets_comp_current: venta.LastYear?.Z6_TicketsComp_CurrentYear ?? 0,
        z6_tickets_comp_last: venta.LastYear?.Z6_TicketsComp_Last ?? 0,

        t1_ventas_comp_current: venta.LastYear?.T1_VentasComp_CurrentYear ?? 0,
        t1_ventas_comp_last: venta.LastYear?.T1_VentasComp_Last ?? 0,
        t1_tickets_comp_current: venta.LastYear?.T1_TicketsComp_CurrentYear ?? 0,
        t1_tickets_comp_last: venta.LastYear?.T1_TicketsComp_Last ?? 0,

        t2_ventas_comp_current: venta.LastYear?.T2_VentasComp_CurrentYear ?? 0,
        t2_ventas_comp_last: venta.LastYear?.T2_VentasComp_Last ?? 0,
        t2_tickets_comp_current: venta.LastYear?.T2_TicketsComp_CurrentYear ?? 0,
        t2_tickets_comp_last: venta.LastYear?.T2_TicketsComp_Last ?? 0,

        t3_ventas_comp_current: venta.LastYear?.T3_VentasComp_CurrentYear ?? 0,
        t3_ventas_comp_last: venta.LastYear?.T3_VentasComp_Last ?? 0,
        t3_tickets_comp_current: venta.LastYear?.T3_TicketsComp_CurrentYear ?? 0,
        t3_tickets_comp_last: venta.LastYear?.T3_TicketsComp_Last ?? 0,

        t4_ventas_comp_current: venta.LastYear?.T4_VentasComp_CurrentYear ?? 0,
        t4_ventas_comp_last: venta.LastYear?.T4_VentasComp_Last ?? 0,
        t4_tickets_comp_current: venta.LastYear?.T4_TicketsComp_CurrentYear ?? 0,
        t4_tickets_comp_last: venta.LastYear?.T4_TicketsComp_Last ?? 0,

        t5_ventas_comp_current: venta.LastYear?.T5_VentasComp_CurrentYear ?? 0,
        t5_ventas_comp_last: venta.LastYear?.T5_VentasComp_Last ?? 0,
        t5_tickets_comp_current: venta.LastYear?.T5_TicketsComp_CurrentYear ?? 0,
        t5_tickets_comp_last: venta.LastYear?.T5_TicketsComp_Last ?? 0,

        t6_ventas_comp_current: venta.LastYear?.T6_VentasComp_CurrentYear ?? 0,
        t6_ventas_comp_last: venta.LastYear?.T6_VentasComp_Last ?? 0,
        t6_tickets_comp_current: venta.LastYear?.T6_TicketsComp_CurrentYear ?? 0,
        t6_tickets_comp_last: venta.LastYear?.T6_TicketsComp_Last ?? 0,

        
        };
        if (!venta.Cadena) return;
        if (v.semana !== 1) {
          v.semana = v.semana - 1; // FIX ERA SIN NADA DE ESTO
          data.push(v);
        }
      });
      exportFromJSON({
        data: data,
        exportType: exportFromJSON.types.xls,
        fileName: `${moment().format("YYYY-MM-DD hh-mm-ss")} - Ventas ${
          selectedYear?.text
        }`,
      });
    },
  });

  let farButtons: ICommandBarItemProps[] = [
    {
      key: "export",
      text: "Exportar año",
      iconProps: { iconName: "Download" },
      onClick: () => {
        getData({
          variables: {
            year: parseInt(`${selectedYear?.text}`) || moment().year(),
            wk1: 1,
            wk2: 53,
          },
        });
      },
    },
  ];

  /*

	position: relative;
    background: red;
    z-index: 2;
    margin-bottom: -38px;
	*/

  const containerStyles = {
    root: {
      position: "relative",
      marginBottom: -35,
      zIndex: 1,
      height: 32,
      padding: "0 0 0 8px",
      width: "calc(100% - 120px)",
      left: 120,
    },
  } as const;

  let isLoading = !!qry.loading || loading || ventasLoading;

  //if(!!ventasData && ventasData.getVenta.length>0) debugger
  return (
    <>
      <Title title={"Ventas"} />
      {isLoading && (
        <div
          style={{
            position: "absolute",
            zIndex: 9,
            left: "calc(60% - 50px)",
            top: 160,
          }}
        >
          <Spinner size={SpinnerSize.large} />
        </div>
      )}
      <div className={`table-container small ${isLoading ? "loading" : ""}`}>
        <Stack horizontal tokens={stackTokens} styles={containerStyles}>
          <Stack horizontal tokens={stackTokens} className="group">
            <Dropdown
              label="Semana"
              placeholder={selectedWeek ? `${parseInt(selectedWeek.text)}` : ""}
              selectedKey={selectedWeek?.key ?? 0}
              options={weekOpts}
              styles={dropdownStyles}
              onChange={changeWeek}
              className="grouped"
            />
            <Dropdown
              label="Año"
              placeholder={selectedYear ? selectedYear.text : ""}
              selectedKey={selectedYear?.key ?? null}
              options={yearOpts}
              styles={dropdownStyles}
              onChange={changeYear}
              className="grouped"
            />
          </Stack>
          <Stack horizontal tokens={stackTokens} className="group">
            <Dropdown
              label="Cadena"
              placeholder={selectedWeek ? "" : ""}
              selectedKey={selectedCadena ? selectedCadena.key : null}
              options={cadsOpts}
              styles={dropdownStyles}
              onChange={changeCadena}
              className="grouped"
            />
          </Stack>

          <div className="falseHeader">
            {!isLoading && (
              <>
                <Checkbox
                  label="Ver todo"
                  onChange={() => {
                    setShowDataColumns(!showDataColumns);
                  }}
                />
                <CommandBar items={[]} farItems={farButtons} />
              </>
            )}
          </div>
        </Stack>

        <CrudTable
          label={"Venta"}
          itemName={"Venta"}
          items={modifiedVentasData}
          source={source}
          columns={columns}
          addQuery={addQuery}
          setQuery={setQuery}
          deleteQuery={deleteQuery}
          refetch={refetch}
          width={100}
          onlyDelete
          multiDelete
          exportFunc={() => {}}
        />
      </div>
    </>
  );
};

export default Ventas;
